export const OrderDetailsSkeleton = () => {

    return (
        <div className="max-w-7xl mx-auto px-4 py-6">
            {/* Header skeleton */}
            <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6 space-y-4 sm:space-y-0">
                <div className="flex items-center">
                    <div className="w-5 h-5 bg-slate-200 rounded-full animate-pulse mr-4"></div>
                    <div>
                        <div className="h-7 w-48 bg-slate-200 rounded animate-pulse mb-1"></div>
                        <div className="h-4 w-32 bg-slate-200 rounded animate-pulse"></div>
                    </div>
                </div>
                <div className="flex space-x-3">
                    <div className="h-9 w-24 bg-slate-200 rounded animate-pulse"></div>
                    <div className="h-9 w-24 bg-slate-200 rounded animate-pulse"></div>
                </div>
            </div>

            {/* Tabs skeleton - matching SamTabedPage */}
            <div className="hidden sm:block">
                <div className="flex space-x-1 rounded-xl bg-white p-1.5 border border-slate-200">
                    {[...Array(4)].map((_, i) => (
                        <div key={i} className="w-full rounded-lg py-3 flex items-center justify-center space-x-2 bg-slate-100/50 animate-pulse">
                            <div className="w-5 h-5 bg-slate-200 rounded"></div>
                            <div className="h-5 w-24 bg-slate-200 rounded"></div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Mobile dropdown skeleton */}
            <div className="sm:hidden">
                <div className="h-10 w-full bg-slate-200 rounded animate-pulse"></div>
            </div>

            {/* Content skeleton - matching TabPanel layout */}
            <div className="mt-6 rounded-xl bg-white p-6 border border-slate-200">
                {/* Optional description header */}
                <div className="mb-4">
                    <div className="h-6 w-48 bg-slate-200 rounded animate-pulse mb-2"></div>
                    <div className="h-4 w-64 bg-slate-200 rounded animate-pulse"></div>
                </div>

                {/* Tab content */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                    {[...Array(6)].map((_, i) => (
                        <div key={i} className="space-y-2">
                            <div className="h-4 w-24 bg-slate-200 rounded animate-pulse"></div>
                            <div className="h-6 w-full bg-slate-200 rounded animate-pulse"></div>
                        </div>
                    ))}
                </div>

                <div className="mt-8 space-y-4">
                    <div className="h-4 w-48 bg-slate-200 rounded animate-pulse"></div>
                    <div className="h-24 w-full bg-slate-200 rounded animate-pulse"></div>
                </div>
            </div>
        </div>
    )
}